import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import ReactDom from 'react-dom';

import * as arrayUtils from '../../utils/array';

// import styles from './style';
import { DetailPart, TitlePart } from '../../Parts';

class DetailTemplate extends Component {

  static mergeDetail(detailList, respData) {
    return detailList.map((info) => {
      // console.log(info);
      if (info.items) {
        arrayUtils.forEach(info.items, (item) => {
          item.value = respData[item.key];
        });
      } else {
        info.value = respData[info.key];
      }

      return info;
    });
  }

  constructor() {
    super();
    this.save = this.save.bind(this);
  }
  save() {
    const { checkValid, getData } = this.editPart;
    if (checkValid()) {
      const comdata = getData();
      this.props.save(comdata);
    }
  }

  render() {
    const { detailList, titlepart, respData } = this.props;
    const mergedDetailList = DetailTemplate.mergeDetail(detailList, respData);
    console.log(mergedDetailList);
    return (
      <div>
        <TitlePart titlepart={titlepart} />
        <DetailPart
          detailList={mergedDetailList}
          data={respData}
        />
      </div>
    );
  }
}

DetailTemplate.propTypes = {
  detailList: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  respData: PropTypes.shape(),
  save: PropTypes.func,
  titlepart: PropTypes.shape()
};

DetailTemplate.defaultProps = {
  valid: [],
  save: () => {},
  titlepart: {},
  respData: {}
};

const render = function (props) {
  ReactDom.render(
    <DetailTemplate
      {...props}
    />,
    document.getElementById('root')
  );
};


export default function renderDetail(props) {
  render(props);
}



// WEBPACK FOOTER //
// ./src/Templates/DetailTemplate/index.js